import React, { forwardRef } from "react";
import styled from "styled-components";
import { ReactComponent as PlayRaw } from "@svgr/webpack?-svgo,+titleProp,+ref!./Play.svg";
import { ReactComponent as StopRaw } from "@svgr/webpack?-svgo,+titleProp,+ref!./Stop.svg";
const Circle = styled.svg`
  fill: transparent;
  stroke: ${props => props.theme.colors.action};
  stroke-width: 2;
  stroke-dasharray: 88;
  stroke-dashoffset: 100;
  transform: rotate(-90deg);
  transition: stroke-dashoffset 20ms linear;
`;
const Container = styled.div`
  position: relative;
`;
const positionStyles = `
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
`;
const Stop = styled(StopRaw)`
  ${positionStyles}
  path {
    fill: ${props => props.theme.colors.action};
  }
`;
const Play = styled(PlayRaw)`
  ${positionStyles}
`;
export const PlayButton = forwardRef((props, ref) => (({
  playing,
  progress,
  ...props
}) => {
  return React.createElement(Container, props, React.createElement(Circle, {
    width: "32",
    height: "32",
    style: {
      strokeDashoffset: 88 - progress * 88
    }
  }, React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14"
  })), !playing ? React.createElement(Play, {
    key: `play${playing}`
  }) : React.createElement(Stop, {
    key: `stop${playing}`
  }));
})({ ...props,
  ref
}));